const COUNTDOWN_WORDS = ["ten", "nine", "eight", "seven", "six", "five", "four", "three", "two", "one"];

function tokens(track = {}) {
  const tags = Array.isArray(track.tags) ? track.tags : [];
  return [track.category, track.overlay_family, track.line_role, track.sequence_group,
    track.spoken_value, track.countdown_word, track.file, track.title, ...tags]
    .map((value) => String(value || "").toLowerCase());
}

export function countdownValue(track = {}) {
  for (const key of ["sequence_value", "countdown_value", "countdown_number"]) {
    const value = Number(track?.[key]);
    if (Number.isInteger(value) && value >= 1 && value <= 10) return value;
  }
  const searchable = tokens(track).join(" ").replace(/[_-]+/g, " ");
  for (let index = 0; index < COUNTDOWN_WORDS.length; index += 1) {
    if (new RegExp(`(?:^|\\W)${COUNTDOWN_WORDS[index]}(?:$|\\W)`).test(searchable)) return 10 - index;
  }
  return null;
}

function isCountdownTrack(track) {
  if (!track?.audio_src) return false;
  const searchable = tokens(track).join(" ");
  return countdownValue(track) !== null && (
    searchable.includes("countdown") || String(track.category || "").toLowerCase() === "countdown_atom"
  );
}

/** Return exactly one complete stable ten-to-one sequence, never a fragment. */
export function orderedFullCountdown(...queues) {
  const byValue = new Map();
  queues.flat().filter(isCountdownTrack).forEach((track) => {
    const value = countdownValue(track);
    if (!byValue.has(value)) byValue.set(value, track);
  });
  const sequence = Array.from({ length: 10 }, (_, index) => byValue.get(10 - index));
  return sequence.every(Boolean) ? sequence : [];
}

export function genericForegroundFallback(queue = []) {
  return queue.filter((track) => {
    if (!track?.audio_src || isCountdownTrack(track)) return false;
    const searchable = tokens(track).join(" ");
    return !searchable.includes("whisper") && !searchable.includes("subliminal");
  });
}
